import React, { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import useAxios from 'hooks/useAxios';

const PatientList = ({ tenantID, selectedPatient, onSelect }) => {
  const API = useAxios();
  const [state, setState] = useState({
    patientList: [],
    loading: false,
    patient: '',
  });

  const { loading, patientList, patient } = state;

  useEffect(() => {
    if (patientList.length && !selectedPatient) {
      setState((pre) => ({ ...pre, patientList: [] }));
    }
  }, [selectedPatient]);

  const findPatient = async (value) => {
    if (!tenantID)
      return setState((pre) => ({ ...pre, patient: value, patientList: [] }));
    setState((pre) => ({ ...pre, patient: value }));
    if (!value) {
      return setState((pre) => ({ ...pre, patientList: [] }));
    }

    if (value && value.length < 3) {
      return setState((pre) => ({ ...pre, patientList: [] }));
    }

    setState((pre) => ({ ...pre, loading: true }));
    try {
      const { data } = await API.post(
        `/${tenantID}/AutoSearch/Patient`, value

      );
      setState((pre) => ({
        ...pre,
        patientList: data,
        loading: false,
      }));
    } catch (error) {
      setState((pre) => ({ ...pre, loading: false }));
    }
  };

  const onSelectPatient = (patient) => {
    onSelect(patient);
  };

  return (
    <Select
      className='form-field-large inner-shadow-field' //npi-name
      classNamePrefix='select'
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={loading}
      placeholder='Enter Patient Name'
      name='color'
      options={patientList}
      value={selectedPatient}
      inputValue={patient}
      onInputChange={findPatient}
      onChange={onSelectPatient}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      // isDisabled={!tenantID}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
    />
  );
};

export default PatientList;
